<div class="modal fade" bsModal #buscaCidades="bs-modal" id="modal" [config]="{backdrop: 'static'}"
     tabindex="-1" role="dialog" aria-labelledby="buscaCidadesModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">Cidades</h4>
        <button type="button" (click)="hide()" class="close pull-right button" aria-label="Close" >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container">
          <div class="row">
            <div class="col-10">
              <input type="search" class="form-control" placeholder="Pesquise a cidade..." #search
              (keyup.enter)="searchCidades(search.value)">
            </div>
            <div class="col-2">
              <button class="btn btn-primary button" (click)="searchCidades(search.value)">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>

          <br>
          
          <div *ngIf="cidades">
            <ngx-datatable
                  class="bootstrap table-responsive"
                  [headerHeight]="50"
                  [limit]="10"
                  [columnMode]="'force'"
                  [footerHeight]="50"
                  [rowHeight]="'auto'"
                  [rows]="cidades"
                  [messages]="{emptyMessage: 'Nenhum registro encontrado'}">
              <ngx-datatable-column prop="codigo" name="Código" [sortable]="true">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.codigo}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column prop="nome">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <span>{{row.nome}}</span>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Selecionar">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <div class="btn-group d-flex justify-content-center">
                    <button type="button" (click)="onSelect(row.codigo, row.nome)" class="btn btn-sm btn-primary button">
                      <i class="fa fa-arrow-right"></i>
                    </button>
                  </div>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary button" data-dismiss="modal" (click)="hide()">Fechar</button>
      </div>
      <ngx-loading [show]="loading"></ngx-loading>
    </div>
  </div>
</div>